import { useLocation } from 'wouter';
import { useNoScroll } from '../hooks/useNoScroll.js';

export default function TitleScreen() {
  useNoScroll();
  const [, setLocation] = useLocation();

  return (
    <div className="min-h-screen tv-bg-stripe flex flex-col items-center justify-center gap-8 p-6">
      <div className="flex flex-col items-center gap-2">
        <p className="tv-telop text-sm">社内パーティーゲーム</p>
        <h1 className="tv-heading text-5xl text-center leading-tight mt-4">
          それいけ<br />採点マン
        </h1>
        <p className="font-body text-tv-ash text-sm text-center mt-2">
          お題を絵で答えてホストに採点してもらおう！
        </p>
      </div>

      <div className="flex flex-col gap-3 w-full max-w-xs">
        <p className="font-heading text-xs text-tv-ash text-center">— マルチプレイ —</p>
        <button
          className="tv-btn tv-btn-red text-xl py-4"
          onClick={() => setLocation('/host')}
        >
          🎤 ホスト開始
        </button>
        <button
          className="tv-btn tv-btn-blue text-xl py-4"
          onClick={() => setLocation('/join')}
        >
          📱 参加する
        </button>

        <p className="font-heading text-xs text-tv-ash text-center mt-2">— 1人で遊ぶ —</p>
        <button
          className="tv-btn tv-btn-yellow text-xl py-3"
          onClick={() => setLocation('/solo')}
        >
          🎨 ソロ採点モード
        </button>
        <button
          className="tv-btn tv-btn-white text-lg py-2"
          onClick={() => setLocation('/rankings')}
        >
          🖼 ギャラリー
        </button>
      </div>
    </div>
  );
}
